import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from '../service/http.service';
import { PdfDocumentHeaderFooter } from '../pdf-document-header-footer';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-pdf-document-header-footer-edit',
  templateUrl: './pdf-document-header-footer-edit.component.html',
  styleUrls: ['./pdf-document-header-footer-edit.component.css']
})
export class PdfDocumentHeaderFooterEditComponent implements OnInit {

  headerFooterForm!: FormGroup;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private router: Router,
    private toastService: ToastMessageService,
    public pdfDocumentService: PdfDocumentTemplateService
  ) { }

  ngOnInit(): void {
    this.headerFooterForm = this.builder.group({
      header: this.pdfDocumentService.selectedHeaderFooter.header,
      footer: this.pdfDocumentService.selectedHeaderFooter.footer
    });
  }

  updateHeaders() {
    this.pdfDocumentService.selectedHeaderFooter.footer = this.headerFooterForm.value.footer;
    this.pdfDocumentService.selectedHeaderFooter.header = this.headerFooterForm.value.header;
    this.httpService.putPdfDocumentHeaderFooters(this.pdfDocumentService.selectedHeaderFooter).subscribe(() => {
      this.toastService.addSuccess("Success", "Updated successfully");
    });
  }

  uploadLogo(files: File[]) {
    console.log(files);
    if (files.length == 0) {
      return;
    }
    let formToSend = new FormData();

    try {
      formToSend.append("file", files[0]);
    }
    catch (error) {
      console.error(error);
      return;
    }

    if (!formToSend.has("file")) {
      return;
    }

    this.httpService.putLogoImage(formToSend, this.pdfDocumentService.selectedHeaderFooter.logoId)
      .subscribe(() => {
        this.toastService.addSuccess("Success", "Logo updated");
      },
        error => {
          console.error(error);
          this.toastService.addError("Error", error.message);
        }
      );
  }
}
